(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            // parent: 'account',
            url: '/reset/finish?key',
            templateUrl: 'app/account/reset/finish/reset.finish.html',
            controller: 'ResetFinishController',
            controllerAs: 'vm',
            data: {
                authorities: []
            }
            // ,
            // views: {
            //     'content@': {
            //         templateUrl: 'app/account/reset/finish/reset.finish.html',
            //         controller: 'ResetFinishController',
            //         controllerAs: 'vm'
            //     }
            // }
        });
    }
})();
